import React, { useEffect, useRef, useState } from "react";
import Box from "src/components/common/Box";
import TextInput from "src/components/common/TextInput";
import Button from "src/components/common/Button";
import styled from "styled-components";
import AppLogo from "src/assets/images/appLogo.svg";
import { useErpLoginQuery, useMsErpLoginQuery } from "src/api/loginAPI";
import { encode as base64_encode } from "base-64";
import { getCookie, setCookie } from "src/utils/cookieUtil";
import { AccountInfo, PublicClientApplication } from "@azure/msal-browser";
import AzureAuthenticationButton from "src/azure/azure-authentication-component";
import { resolveMsLoginError } from "src/utils/msLoginError";
import { runMsLoginRetry, shouldRetryMsLogin, startMsLogin } from "src/utils/msLoginRetry";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { MSAL_CONFIG } from "src/azure/azure-authentication-config";
import ErrorParser from "src/utils/jsonParser";
import Loading from "../Loading";
import CheckBox from "../../components/common/CheckBox";

const serverIp = process.env.REACT_APP_SERVER_IP;
const myMSALObj: PublicClientApplication = new PublicClientApplication(MSAL_CONFIG);

const Login = () => {
  const hash = location.hash;
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    id: "",
    password: "",
    query: true,
    errors: false,
  });

  const { id, password, query } = inputs;

  const [isWrongId, setWrongId] = useState(false);
  const [isWrongPw, setWrongPw] = useState(false);

  const changes = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, id } = e.target;
    setInputs({
      // inputs의 복사
      ...inputs,
      [id]: value,
    });
    setSkip(true);
  };

  // base-64 인코딩
  const idPass = id + ":::::" + password;
  const secretData = base64_encode(unescape(encodeURIComponent(idPass)));

  const [skip, setSkip] = useState(query);
  // api 데이터
  const { data, error, isLoading, isSuccess, isError } = useErpLoginQuery({ secret: secretData }, { skip });

  // useEffect(() => {
  //   const accessTokenRequest = {
  //     scopes: ["user.read"],
  //   };
  //   myMSALObj.acquireTokenRedirect(accessTokenRequest);
  // }, []);
  const [checked, setChecked] = useState(false);

  const loginBtnClick = () => {
    if (!checked) return alert("이용약관/사용자 정책 동의에 체크해주세요.");
    if (error) {
      alert("아이디를 다시 확인해 주세요");
    } else {
      setSkip(false);
    }
  };

  useEffect(() => {
    if (error) {
      // alert("정보가 잘못 되었습니다.");
      const errorString = JSON.stringify(error);
      const errorJson = JSON.parse(errorString);
      if (errorJson["data"].message === "PWD") {
        setWrongPw(true);
      }
      if (errorJson["data"].message === "ID") {
        setWrongId(true);
      }
    }
  }, [error]);
  // token 값 저장

  // ERP login
  // 매장, 업체 로그인
  useEffect(() => {
    if (isSuccess) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ ac_token: data?.data.accessToken, re_token: data?.data.refreshToken }));
      }
      setCookie("re_token", data?.data.refreshToken, { samSite: "strict" });
      setCookie("ac_token", data?.data.accessToken, { samSite: "strict" });

      location.href = "/home";
      // navigate("/home");
    }
  }, [isSuccess]);

  // MS 인증
  // const [currentUser, setCurrentUser] = useState<AccountInfo>();
  // authentication callback
  const [token, setToken] = useState<any>({
    ac_token: "",
    reflash: false,
  });
  const { ac_token, reflash } = token;

  const originOnToken = async (resultToken: string) => {
    setToken({
      ...token,
      ac_token: resultToken,
      reflash: true,
    });
  };

  const [msSkip, setMsSkip] = useState(true);

  useEffect(() => {
    if (reflash) {
      setToken({
        ...token,
        reflash: false,
      });
      setMsSkip(false);
    }
  }, [ac_token, reflash]);

  // ERP DB에서 정보 가지고 와서 token 받아옴
  const msLogin = useMsErpLoginQuery(ac_token, { skip: msSkip });

  // MStoken 값 저장
  useEffect(() => {
    if (msLogin.isSuccess) {
      setMsSkip(true);
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ ac_token: msLogin.data?.data.accessToken, re_token: data?.data.refreshToken }));
      }
      setCookie("re_token", msLogin.data?.data.refreshToken, { samSite: "strict" });
      setCookie("ac_token", msLogin.data?.data.accessToken, { samSite: "strict" });
      location.href = "/home";
    }
  }, [msLogin.isSuccess]);

  useEffect(() => {
    localStorage.removeItem("@BRAND");
  }, []);

  useEffect(() => {
    if (msLogin.isError) {
      const message = ErrorParser(msLogin.error);
      alert(message);
      location.href = "/";
      // navigate("/");
    }
  }, [msLogin.isError]);

  // VMD-399: MS 리다이렉트 복귀 처리용 1회성 플래그 두 개.
  // msRetryFired 가 근본 수정이다 — 재로그인이 두 번 이상 발사되지 않게 막는다.
  // msLoginSucceeded 는 2차 방어다. 요청이 한 번만 나가면 '형제 요청이 이동에
  // 취소되는' 시나리오는 사실상 재현되지 않지만, 성공한 로그인을 되돌리는 것이
  // 이 결함의 가장 큰 피해였으므로 분기를 남겨 테스트로 고정해 둔다.
  const msRetryFiredRef = useRef(false);
  const msLoginSucceededRef = useRef(false);

  // let reMsLogin: any;
  // ms 로그인을 front-end에서 할때 로그인이 되는 대시 hash 태그를 주는 경우가 있다
  // 이때 다시 재 로그인을 시켜주기 위한 로직
  const reMsLogin = async (params: string) => {
    try {
      const response = await axios.post(
        serverIp + "/auth/login/ms",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + params,
          },
        },
      );
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ ac_token: response.data.data["accessToken"], re_token: response.data.data["refreshToken"] }));
      }
      setCookie("re_token", response.data.data["refreshToken"], { samSite: "strict" });
      setCookie("ac_token", response.data.data["accessToken"], { samSite: "strict" });
      msLoginSucceededRef.current = true;
      location.href = "/home";
    } catch (error) {
      // VMD-399: 예전 코드는 stringify 한 에러에서 "401" 을 문자열로 찾고 나머지 전부를
      // "서버 오류 발생" 알럿 뒤 location.href = "/" 로 보냈다. /home 이동이 취소시킨
      // 요청은 상태코드가 없어 그 분기로 떨어졌고, 그래서 성공한 로그인이 되돌려졌다.
      const action = resolveMsLoginError(error, msLoginSucceededRef.current);
      if (action.kind === "ignore") {
        console.warn("MS login:", action.reason);
        return;
      }
      alert(action.message);
      location.href = "/";
    }
  };

  const reLoginOnToken = (resultToken: string) => {
    setToken({
      ...token,
      ac_token: resultToken,
      reflash: false,
    });
    if (resultToken) {
      reMsLogin(resultToken);
    }
  };

  // useEffect(() => {
  //   const azure = document.getElementById("authenticationButton");
  //   azure?.click();
  // },[])

  // VMD-399: 로그인 버튼을 프로그램에서 다시 눌러준다. 이 블록은 렌더 본문에 있었고,
  // #code 가 URL 에 남아 있는 동안 리렌더마다 /auth/login/ms 를 다시 POST 했다. 가장 먼저
  // 응답한 호출이 /home 으로 이동을 시작하면 그 이동이 남은 요청을 취소시키고, 취소된 요청이
  // 위 catch 로 떨어져 location.href = "/" 로 성공한 로그인을 되돌렸다. 마운트 시 1회만 실행한다.
  //
  // VMD-405: 그 수정이 재시도를 1회도 발사하지 못하게 만들었다. useEffect 안에서
  // AzureAuthenticationButton 을 함수로 직접 부르면 그 컴포넌트의 useState 가 렌더 밖에서
  // 호출돼 Invalid hook call 로 던지고, 곁의 try/catch 가 그것을 삼켰다. 컴포넌트를 거치지
  // 않고 리다이렉트 컨텍스트를 직접 쓰는 runMsLoginRetry 로 바꾼다 — msLoginRetry.ts 참조.
  // 버튼 활성화를 받는 자리. 재시도와 같은 직접 경로를 쓰고 컴포넌트를 거치지 않는다.
  const onMsLoginClick = () => {
    startMsLogin(originOnToken).then((ok) => {
      if (!ok) alert("Microsoft 로그인을 시작할 수 없습니다. 잠시 후 다시 시도해 주세요.");
    });
  };

  useEffect(() => {
    if (msRetryFiredRef.current) return;
    if (!shouldRetryMsLogin(hash)) return;
    msRetryFiredRef.current = true;
    runMsLoginRetry(reLoginOnToken).then((ok) => {
      // 실패를 조용히 두면 사용자는 로그인 화면에 멈춘 채 아무 안내도 받지 못한다.
      // 이 마운트에서 재시도는 다시 발사되지 않으므로 다음에 할 일을 알려 준다.
      if (!ok) alert("로그인이 자동으로 이어지지 않았습니다. 아래 Microsoft 버튼을 한 번 더 눌러 주세요.");
    });
    // 마운트 1회만 실행하는 것이 이 수정의 핵심이므로 의존성을 비워 둔다.
    // 이 저장소의 eslint 설정에는 react-hooks 플러그인이 없어
    // react-hooks/exhaustive-deps 를 disable 하는 주석을 달면 '규칙 정의를 찾을 수
    // 없다' 는 오류가 난다. 그래서 directive 대신 이 주석으로 의도를 남긴다.
  }, []);

  // #.1 로그인 버튼을 다시 누르도록 가이드를 주는 방법 (best)
  // useEffect(() => {
  //   if (hash.indexOf("#code") > -1) {
  //     alert("다시 로그인을 시도하시기 바랍니다.");
  //   }
  // }, []);

  function onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key == "Enter") loginBtnClick();
  }

  const onCheckedHandle = () => {
    setChecked(!checked);
  };

  return (
    <>
      {msLogin.isLoading ? (
        <Loading />
      ) : (
        <>
          <LoginTitleWrap>
            <p className="title">안녕하세요.</p>
          </LoginTitleWrap>
          <Box bg="#f4f4f4" pd="30px 15px">
            {/* VMD-409: 이 화면에는 인증 경로가 둘인데 라벨이 없어 본사 임직원이 위쪽 폼을
                자기 경로로 읽는 일이 있었다. 위쪽은 smsLogin 후 scmLogin 이라 매장과
                협력업체만 통과하고, 본사 계정은 아래 Microsoft 경로로만 들어온다.
                부제 'SMS와 동일한 계정을 사용합니다' 도 두 경로 위에 걸려 있었지만
                위쪽에만 참이므로 여기로 내린다. */}
            <PathLabel>
              <p className="path-name">매장 및 협력업체</p>
              <p className="path-desc">SMS와 동일한 계정을 사용합니다.</p>
            </PathLabel>
            <TextInput type="text" id="id" name="id" label="아이디" onChange={changes} />
            {isWrongId && (
              <NoticeText>
                <p>일치하는 아이디가 없습니다.</p>
              </NoticeText>
            )}
            <TextInput type="password" id="password" name="password" label="비밀번호" onChange={changes} onKeyPress={onKeyPress} />
            {isWrongPw && (
              <NoticeText>
                <p>비밀번호가 일치하지 않습니다.</p>
                <p>지속 실패 시 본사 IT팀(02-520-6464)으로 연락 주세요.</p>
              </NoticeText>
            )}
            {/* <CheckBoxWrap>
              <CheckBox id="basic-checkbox1" checked={true} label="로그인 유지" />
            </CheckBoxWrap> */}
            {/* <div onClick={() => setSkip((prev) => !prev)}> */}
            <PolicyBox>
              <CheckBox id="check" type="round" label={"이용약관/사용자 정책 동의"} checked={checked} onChange={onCheckedHandle} />
              <Link to={"/privacy"}> (내용확인)</Link>
            </PolicyBox>
            <ButtonBox onClick={() => loginBtnClick()}>
              <Button variant="contained" br="round">
                로그인
              </Button>
            </ButtonBox>
          </Box>
          <div></div>
          <OptionButtonWrap>
            <PathLabel>
              <p className="path-name">본사 임직원</p>
              <p className="path-desc">회사 이메일 계정으로 로그인합니다.</p>
            </PathLabel>
            {/* 활성화는 실제 <button> 인 Button 이 받는다. 안쪽 div 에 onClick 을 달면
                마우스로만 눌리고 키보드 Enter 및 Space, 보조기술, 프로그램 호출은
                조용히 무동작이 된다 — 키보드만 쓰는 사용자가 로그인을 못 했던 이유다. */}
            <Button variant="outlined" br="round" onClick={onMsLoginClick} aria-label="본사 임직원 Microsoft 로그인">
              {/* <AzureAuthenticationButton onAuthenticated={onAuthenticated} /> */}
              <AzureAuthenticationButton onAuthenticated={originOnToken} />
            </Button>
          </OptionButtonWrap>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#94999f", fontSize: "13px" }}>
            <div>비밀번호 초기화 문의: 02-520-6464</div>
            <div>기타 문의: 담당 VMD</div>
          </div>
        </>
      )}
    </>
  );
};

const LoginTitleWrap = styled.div`
  padding: 80px 15px 90px;
  padding-top: calc(${({ theme }) => theme.mobile.notchHeight}px + 80px);
  .title {
    ${/* padding-top 88px 는 아래 주석 처리된 배경 로고의 자리를 비워 두던 값이다. 로고가
       그려지지 않으므로 빈 공간이었고, VMD-409 로 라벨 두 줄이 늘어난 만큼을 여기서
       돌려받는다. 이 공간이 남아 있으면 노치 단말에서 Microsoft 버튼이 첫 화면 아래로
       밀려 — 이 수정이 찾게 하려던 바로 그 버튼이 — 접힌다. */ ""}
    /* background: url(${AppLogo}) no-repeat left top; */
    font-size: 40px;
  }
`;

const PathLabel = styled.div`
  margin-bottom: 20px;
  ${/* 두 경로 모두 path-name 과 path-desc 를 함께 두십시오. path-name 18px/700 은
     TextInput 의 라벨 16px/700 과 굵기도 색도 같아 2px 차이뿐이고, 이것이 구역
     제목으로 읽히는 것은 바로 아래 붙는 회색 설명 줄이 제목과 부제의 짝을 만들기
     때문입니다. 어느 한쪽의 설명을 지우면 그 라벨은 다시 세 번째 입력 라벨처럼
     보입니다. 크기만으로 세우려면 색이나 자간으로 축을 하나 더 주십시오. */ ""}
  .path-name {
    font-size: 18px;
    font-weight: 700;
  }
  .path-desc {
    margin-top: 6px;
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 14px;
  }
`;

const ButtonBox = styled.div`
  margin-top: 30px;
`;
const PolicyBox = styled.div`
  margin-top: 15px;
`;

const OptionButtonWrap = styled.div`
  position: relative;
  padding: 60px 15px;
  ::before {
    content: "or";
    z-index: 10;
    position: absolute;
    left: 50%;
    top: 22px;
    transform: translate(-25px);
    display: inline-block;
    padding: 0 18px;
    background-color: #fff;
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 16px;
  }
  ::after {
    content: "";
    position: absolute;
    left: 15px;
    top: 30px;
    display: inline-block;
    width: calc(100% - 30px);
    height: 1px;
    background-color: ${({ theme }) => theme.color.lineSecondary};
  }
`;

const NoticeText = styled.div`
  margin: 5px 0 15px;
  > p {
    color: ${({ theme }) => theme.color.warning};
  }
`;

export default Login;
